export default __webpack_public_path__ + "static/media/ico_details.13bca84e.svg";